module.exports = __webpack_public_path__ + "img/fileeob.565ae0bd.svg";